const ENV_NAME = process.env.REACT_APP_ENV_NAME as string;

export const isDebug = (): boolean => {
    const url = window.location.href;
    return ENV_NAME === 'development' || !url.includes('app.jarbas.ai');
};
